import PropTypes from "prop-types";
import AudienceContext from "./audienceContext";
import DecisionsContext from "./decisionsContext";
import withJsonIsomorphism from "../withJsonIsomorphism";

const providerFactory = (Context, propName) =>
  withJsonIsomorphism(
    ({ children, ...rest }) => (
      <Context.Provider value={rest[propName]}>{children}</Context.Provider>
    ),
    {
      scriptId: `plp_${propName}`,
      propName
    }
  );

const AudienceProvider = providerFactory(AudienceContext, "audience");
const DecisionsProvider = providerFactory(DecisionsContext, "decisions");

const FeaturesProvider = ({
  children,
  experiments: { audience = null, decisions = null } = {}
}) => (
  <AudienceProvider audience={audience}>
    <DecisionsProvider decisions={decisions}>{children}</DecisionsProvider>
  </AudienceProvider>
);

FeaturesProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired,
  experiments: PropTypes.shape({
    decisions: PropTypes.object,
    audience: PropTypes.object
  })
};

export default FeaturesProvider;
